<template>
  <div>
    <VaModal
      v-model="showAlertModal"
      size="medium"
      hide-default-actions
      overlay-opacity="0.2"
      @clickOutside="modalClosed()"
    >
      <template #header>
        <h3 class="font-normal text-lg">
          Select your alert preferences for
          <span class="font-medium">{{ alertStore.domain ? alertStore.domain : domainStore.domain }}</span>
        </h3>
      </template>
      <div class="mt-12">
        <div class="flex gap-12 justify-center">
          <div>
            <VaSwitch v-model="alertParams.low_inbox_alert" size="small" label="Daily inbox alert" left-label />
          </div>
          <div>
            <VaSwitch v-model="alertParams.weekly_inbox_alert" size="small" label="Weekly inbox alert" left-label />
          </div>
        </div>
        <div class="flex gap-12 justify-center mt-12">
          <div v-if="alertParams.low_inbox_alert" class="flex items-center gap-2">
            <label for="">Alert %</label>
            <VaSelect
              v-if="!customAlert"
              v-model="alertParams.alert_percent"
              class="w-20"
              :options="options"
              placeholder="Alert %"
              left-label
              @change="checkAlertType"
            />
            <div v-else class="flex items-center gap-4 cursor-pointer">
              <VaInput v-model="alertParams.alert_percent" class="w-20 text-center" type="number" />
              <div @click="customAlert = false">
                <img src="@/assets/icons/close.svg" alt="" width="20" height="20" />
              </div>
            </div>
          </div>

          <div v-else class="flex items-center gap-2">
            <label for="">Alert %</label>
            <VaSelect class="w-20" :options="options" placeholder="Alert %" left-label disabled />
          </div>
          <div v-if="alertParams.low_inbox_alert" class="flex items-center gap-2">
            <label for="">Frequency in hours</label>
            <VaSelect
              v-model="alertParams.frequency"
              placeholder="Select an option"
              class="w-20"
              :options="frequencyOptions"
            />
          </div>
          <div v-else class="flex items-center gap-2">
            <label for="">Frequency in hours</label>
            <VaSelect disabled placeholder="Select an option" class="w-20" :options="frequencyOptions" />
          </div>
        </div>
      </div>
      <template #footer>
        <div>
          <VaButton class="mt-12 mr-8 text-white" color="#F87171" @click="closeModal()">
            <span class="text-white">Cancel</span></VaButton
          >
          <VaButton class="mt-12" @click="setAlert()">Set alert</VaButton>
        </div>
      </template>
    </VaModal>
  </div>
</template>
<script setup>
import { ref, watch, onMounted } from 'vue'
import { useDomainStore } from '../stores/dashBoardStore'
import { useToast } from 'vuestic-ui'
import { patchData } from '../data/api/fetchData'
import { useAuthStore } from '../stores/authStore'
import { useAlertStore } from '../stores/alertStore'

const alertStore = useAlertStore()
const emit = defineEmits(['alertSet'])
const authStore = useAuthStore()
const email = authStore.email
const { init } = useToast()
const domainStore = useDomainStore()
const domain = ref(domainStore.domain)
const showAlertModal = ref(false)
const options = ref([25, 55, 75, 'custom'])
const frequencyOptions = ref([1, 5, 10])
const customAlert = ref(false)

const alertParams = ref({
  low_inbox_alert: false,
  weekly_inbox_alert: true,
  alert_percent: 50,
  frequency: 5,
  email: email,
})

if (alertStore.updateData && alertStore.domain) {
  console.log('TRUEEE =====')
  alertParams.value = alertStore.updateData
  domain.value = alertStore.domain
}

const toggleAddAlertModal = () => {
  showAlertModal.value = !showAlertModal.value
}

const checkAlertType = () => {
  if (alertParams.value.alert_percent === 'custom') {
    alertParams.value.alert_percent = 0
    customAlert.value = true
    console.log(alertParams.value.alert_percent)
  } else if (alertParams.value.alert_percent > 100 || alertParams.value.alert_percent < 0) {
    console.log(alertParams.value.alert_percent)
    init({ message: 'Alert percent should be between 0 and 100', color: '#f87171' })
    alertParams.value.alert_percent = 0
    return
  }
}

const setAlert = async () => {
  alertParams.value.alert_percent = Number(alertParams.value.alert_percent)
  const res = await patchData(
    `user/set-alert/${encodeURIComponent(alertStore.domain ? alertStore.domain : domainStore.domain)}`,
    alertParams.value,
  )
  if (res.status === 'failed') {
    init({ message: res.message, color: '#f87171' })
  }
  console.log('Alert data : ', res)
  modalClosed()
  emit('alertSet')
  toggleAddAlertModal()
}

const closeModal = () => {
  showAlertModal.value = false
  domain.value = domainStore.domain
  modalClosed()
}

const modalClosed = () => {
  alertStore.updateDomain(null)
  domain.value = domainStore.domain
}

watch(
  () => alertStore.updateData,
  () => {
    alertParams.value = alertStore.updateData
  },
)

watch(
  () => alertStore.domain,
  () => {
    domain.value = alertStore.domain
  },
)

watch(
  () => alertParams.value.alert_percent,
  () => {
    checkAlertType()
  },
)

watch(
  () => domainStore.domain,
  () => {
    domain.value = domainStore.domain
  },
)

onMounted(() => {
  if (alertStore.updateData && alertStore.domain) {
    console.log('TRUEEE =====')
    alertParams.value = alertStore.updateData
    domain.value = alertStore.domain
  }
})

defineExpose({
  toggleAddAlertModal,
})
</script>
